(() => {
  const config = document.getElementById('ra-ryzo-premium-config');
  if (!config) return;
  const labels = config.dataset;
  const mounted = new WeakSet();
  const selector = '.ryzo-modal-overlay.ryzo-root';
  const choiceSelector = '.ryzo-size-swatch, .ryzo-color-swatch';
  let pending = false;
  const selected = el => Array.from(el.classList).some(name => name.endsWith('-selected'));
  const choices = row => Array.from(row.querySelectorAll(choiceSelector)).filter(el => el.getAttribute('aria-disabled') !== 'true' && !Array.from(el.classList).some(name => name.includes('disabled') || name.includes('sold-out')));
  const missingRow = card => Array.from(card.querySelectorAll('.ryzo-color-swatches')).find(row => {
    const items = choices(row);
    return items.length > 1 && !items.some(selected);
  });
  const keyboardClick = event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const target = event.target.closest('[data-ra-keyboard]');
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    target.click();
  };
  const enhance = root => {
    const modal = root.querySelector('.ryzo-modal-container');
    const heading = root.querySelector('.ryzo-modal-title');
    if (modal && heading) {
      if (!heading.id) heading.id = 'ra-ryzo-search-title';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', heading.id);
    }
    const close = root.querySelector('.ryzo-modal-close');
    if (close) close.setAttribute('aria-label', labels.close);
    root.querySelectorAll('.ryzo-text-product-card').forEach(card => {
      const title = card.querySelector('.ryzo-product-title');
      const name = title ? title.textContent.trim() : '';
      if (title) {
        title.title = name;
        title.setAttribute('role', 'link');
        title.tabIndex = 0;
        title.dataset.raKeyboard = 'true';
      }
      const image = card.querySelector('.ryzo-product-image');
      if (image && name) image.alt = name;
      card.querySelectorAll(choiceSelector).forEach(el => {
        el.setAttribute('role', 'button');
        el.tabIndex = 0;
        el.dataset.raKeyboard = 'true';
        el.setAttribute('aria-label', el.getAttribute('title') || el.textContent.trim());
        el.setAttribute('aria-pressed', String(selected(el)));
      });
      card.querySelectorAll('.ryzo-wishlist-button, .ryzo-search-icon').forEach(el => {
        el.setAttribute('role', 'button');
        el.tabIndex = 0;
        el.dataset.raKeyboard = 'true';
        const label = el.getAttribute('data-tooltip');
        if (label) el.setAttribute('aria-label', label + ': ' + name);
      });
      const button = card.querySelector('.ryzo-add-to-cart-mobile');
      if (button) button.setAttribute('aria-label', (button.textContent.trim() || labels.add) + ': ' + name);
      card.querySelectorAll('.ra-ryzo-option-needed').forEach(row => {
        if (choices(row).some(selected)) row.classList.remove('ra-ryzo-option-needed');
      });
      if (!missingRow(card)) {
        const hint = card.querySelector('.ra-ryzo-hint');
        if (hint) hint.hidden = true;
      }
    });
  };
  const mount = root => {
    if (mounted.has(root)) return;
    mounted.add(root);
    root.addEventListener('keydown', keyboardClick);
    root.addEventListener('click', event => {
      const button = event.target.closest('.ryzo-add-to-cart-mobile, .ryzo-add-to-cart-desktop');
      if (!button) return;
      const card = button.closest('.ryzo-text-product-card');
      if (!card) return;
      const row = missingRow(card);
      if (!row) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      row.classList.add('ra-ryzo-option-needed');
      let hint = card.querySelector('.ra-ryzo-hint');
      if (!hint) {
        hint = document.createElement('p');
        hint.className = 'ra-ryzo-hint';
        hint.setAttribute('role', 'status');
        card.querySelector('.ryzo-add-to-cart-mobile').before(hint);
      }
      hint.textContent = labels.choose;
      hint.hidden = false;
      const first = choices(row)[0];
      if (first) first.focus({preventScroll:true});
      row.scrollIntoView({block:'nearest',behavior:'auto'});
    }, true);
    new MutationObserver(schedule).observe(root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class']});
  };
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      document.querySelectorAll(selector).forEach(root => {mount(root); enhance(root);});
    });
  }
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) schedule();
  }).observe(document.body,{childList:true,subtree:true});
  schedule();
})();